(function() {
    'use strict';


angular.module('app.controllers.device.coolingCurve', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('device.coolingcurve', {
            parent: 'device',
            url: '/coolingcurve/:coolingCurve',
            templateUrl: 'views/device.coolingcurve.html',
            defaultParams: {coolingCurve: '1'},
            controller: 'CoolingcurveCtrl',
            resolve: {
                coolingCurveDatapoint : function(conf_wellKnownObjects,$stateParams){
                    'ngInject';

                    return conf_wellKnownObjects['CoolingCurve'+$stateParams.coolingCurve];
                }

            },
            breadcrumb: {
                name: function () {
                    return 'NAV_CoolingCurve';
                }
            }
        });
        $stateProvider.state('device.coolingcurve.edit', {
            parent: 'device.coolingcurve',
            url: '/edit'
        });
    }])
    .controller("CoolingcurveCtrl", [
        '$rootScope',
        '$scope',
        '$filter',
        'coolingCurveDatapoint',

        'actualDevice',
        '__DatapointValue',
        'f_User',
        '__MenuEntry',

        'viewMenuBarService',
        '$stateParams',
        '$translate',
        '__DatapointConfig',

        function (
            $rootScope,
            $scope,
            $filter,
            coolingCurveDatapoint,

            actualDevice,
            __DatapointValue,
            f_User,
            __MenuEntry,

            viewMenuBarService,
            $stateParams,
            $translate,
            __DatapointConfig
        )
            {

            function getMenuEntryId(stateParams) {
                if (stateParams.menuEntry && stateParams.menuEntry.MenuEntryId) {
                    return stateParams.menuEntry.MenuEntryId;
                }
                if ($stateParams.configData && $stateParams.configData.EntryId) {
                    return $stateParams.configData.EntryId;
                }
                return null;
            }

            var favoriteObject
            = {
                favoriteType : 'MenuEntry',
                favoriteObject:
                    __MenuEntry.$buildRaw({
                        "$type" : "BMS.Shared.Model.System.FavoriteCustomAction, BMS.Shared",
                        "MenuEntryId": getMenuEntryId($stateParams),
                        "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                        "DeviceId": actualDevice.DeviceId,
                        'CustomActionName': 'CoolingCurve'+$stateParams.coolingCurve,
                        'DisplayName': $translate.instant('NAV_CoolingCurve'),
                        'ImageName': 'statistik',

                        $UI:{}
                    })
            };
            viewMenuBarService.setFavorite(favoriteObject);

            this.$onInit = function() {
                initializeData();
            };

            function initializeData() {
                $rootScope.backbutton = true;
                $scope.yAxis = [];
                for (var i = 65; i >= 5; i = i - 5) {
                    $scope.yAxis.push(i);
                }
                var a = [{'DatapointConfigId':coolingCurveDatapoint,DeviceId:actualDevice.DeviceId}];

                $scope.curve = __DatapointValue.$collection(a).$refresh().$then(function(data){


                    var r = $scope.curve[0];

                    if (r.Value && r.Value.CurveValues) {
                        r.Value.CurveValues = $filter('orderBy')(r.Value.CurveValues, '-XValue');
                    }
                    $scope.curve = r;
                    $scope.curve.desc = {
                        xVal: {
                            type: 'temperature',
                            text: 'COOLINGCURVE_Aussen'
                        },
                        yVal: {
                            type: 'temperature',
                            text: 'COOLINGCURVE_Vorlauf'
                        }
                    };

                });
                __DatapointConfig
                .$ByDeviceId(
                    {
                        DeviceId: actualDevice.DeviceId,
                        DatapointConfigIds:[coolingCurveDatapoint]
                    }
                )
                .$then(function(data){
                    var dp = data[0];
                    $scope.userCanEdit = (f_User.getUserLevel() >= dp.UserLevelWrite ? true : false);
                });
            }

            $scope.editCurve = function (c) {
                $scope.tempCurve = angular.copy(c);
                c.$UI.editMode = true;
            };

            $scope.saveCurve = function (c) {
                delete c.$UI.editMode;
                c.$save();
            };

            $scope.revertCurve = function (c) {
                c.Value  = angular.copy($scope.tempCurve.Value);
                c.Value.CurveValues  = angular.copy($scope.tempCurve.Value.CurveValues);
            };

            $scope.$on('UserlevelChange', function () {
                initializeData();
            });

        }]);

})();
